module.exports = __webpack_public_path__ + "img/5_99.0c682445.png";